<template>
  <b-container
    class="bv-example-row bv-example-row-flex-cols table-wrapper"
    fluid
  >
    <!-- <b-row align-v="center" class="filter-wrapper">
      <b-col>
        <test-filter-component
          :status-filter.sync="statusFilter"
          :hospital-selected.sync="hospitalSelected"
          :direction-filter-selected.sync="directionFilterSelected"
        />
      </b-col>
    </b-row>-->
    <b-row>
      <b-table
        striped
        hover
        small
        outlined
        bordered
        foot-clone
        show-empty
        :current-page="currentPage"
        :per-page="perPage"
        :fields="fieldsComputed"
        :items="itemsFilterComputed"
      >
        <template slot="no" slot-scope="data">
          <div class="col-right">
            {{ $numeral(data.index + 1).format("0,0[.]00") }}
          </div>
        </template>
        <template slot="hospital_name" slot-scope="data">
          <div class="col-left">{{ data.item.hospital_name }}</div>
        </template>
        <template slot="direction" slot-scope="data">
          <div class="col-left">{{ data.item.direction }}</div>
        </template>
        <template slot="name" slot-scope="data">
          <div class="col-left">{{ data.item.name }}</div>
        </template>
        <template slot="amount" slot-scope="data">
          <div class="col-right">
            {{ $numeral(data.item.amount).format("0,0[.]00") }}
          </div>
        </template>
        <template slot="spp" slot-scope="data">
          <div class="col-left">{{ data.item.spp }}</div>
        </template>
        <template slot="totalPrice" slot-scope="data">
          <div class="col-right">
            {{ $numeral(data.item.totalPrice).format("0,0[.]00") }}
          </div>
        </template>
        <template slot="FOOT_no">
          <div class="col-right"></div>
        </template>
        <template slot="FOOT_hospital_name">
          <div class="col-right"></div>
        </template>
        <template slot="FOOT_direction">
          <div class="col-right"></div>
        </template>
        <template slot="FOOT_name">
          <div class="col-right"></div>
        </template>
        <template slot="FOOT_spp">
          <div class="col-right"></div>
        </template>
        <template slot="FOOT_amount">
          <div class="col-right">รวม</div>
        </template>
        <template slot="FOOT_totalPrice">
          <div class="col-right">
            {{
              $numeral(
                itemsFilterComputed
                  .reduce((a, b) => a + +b.totalPrice, 0)
                  .toFixed(2)
              ).format("0,0[.]00")
            }}
          </div>
        </template>
      </b-table>
    </b-row>
    <b-row>
      <b-col cols="auto">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import testFilterComponent from "./testFilterComponent";
import { mapActions } from "vuex";
import * as moment from "moment";

export default {
  name: "AnimalTable",
  components: {
    testFilterComponent,
  },
  props: {
    hospitalSelected: {
      required: true,
    },
    reportType: {
      required: true,
    },
    itemsFilter: {
      required: true,
    },
    itemsObject: {
      required: true,
    },
    dateType: {
      required: true,
    },
    fromDate: {
      required: true,
    },
    toDate: {
      required: true,
    },
    directionFilterSelected: {
      required: true,
    },
    creditTypeSelected: {
      required: true,
    },
    statusFilter: {
      required: true,
    },
  },
  data() {
    return {
      // hospitalSelected: null,
      statusFilter: null,
      directionFilterSelected: null,
      fields: [
        {
          index: 1,
          key: "no",
          label: "ลำดับ",
        },
        {
          index: 2,
          key: "hospital_name",
          label: "โรงพยาบาล",
        },
        {
          index: 3,
          key: "direction",
          label: "เส้นทาง",
        },
        {
          index: 7,
          key: "amount",
          label: "จำนวน",
        },
        {
          index: 8,
          key: "totalPrice",
          label: "ราคารวม",
        },
      ],
    };
  },
  computed: {
    fieldsComputed() {
      if (this.hospitalSelected === "all" || !this.hospitalSelected) {
        return this.fields.sort(this.fieldIndex);
      } else {
        return this.$rfdc([
          ...this.fields,
          {
            index: 5,
            key: "name",
            label: "PATIENT",
          },
          {
            index: 6,
            key: "spp",
            label: "SPP",
          },
        ]).sort(this.fieldIndex);
      }
    },
    itemsFilterComputed: {
      get() {
        return this.itemsFilter;
      },
      set(value) {
        this.$emit("update:itemsFilter", value);
      },
    },
  },
  methods: {
    ...mapActions({
      filter: "Account/reportAnimalFilter",
    }),
    async filters() {
      // check input informed ?

      this.$store.state.isLoading = true;
      let firstDate = moment(this.fromDate);
      let lastDate = moment(this.toDate);

      if (this.dateType === "date") {
        firstDate = firstDate.startOf("days");
        lastDate = lastDate.endOf("days");
      } else if (this.dateType === "month") {
        firstDate = firstDate.startOf("months");
        lastDate = lastDate.endOf("months");
      } else if (this.dateType === "year") {
        firstDate = firstDate.startOf("years");
        lastDate = lastDate.endOf("years");
      }
      firstDate = firstDate.unix();
      lastDate = lastDate.unix();

      //   let firstDate = new Date(
      //     this.fromDate.getFullYear(),
      //     this.fromDate.getMonth(),
      //     this.fromDate.getDate()
      //   );
      //  let date = 0;
      // if (this.dateType === 'date') {
      //   date = this.toDate.getDate();
      // }

      //   let lastDate;
      // if (this.dateType === 'date') {
      // lastDate = new Date(
      //   this.toDate.getFullYear(),
      //   this.toDate.getMonth(),
      //   this.toDate.getDate() + 1
      // );
      // } else {
      //   lastDate = new Date(
      //   this.toDate.getFullYear(),
      //   this.toDate.getMonth() + 1,
      //   0
      // );
      // }

      let result = await this.filter({
        hospital_selected: this.hospitalSelected,
        status_filter: this.statusFilter,
        date_type: this.dateType,
        from_date: firstDate,
        to_date: lastDate,
        direction_filter_selected: this.directionFilterSelected,
        credit_type_selected: this.creditTypeSelected,
      });

      if (result.success) {
        this.itemsFilterComputed = result.result;
        this.$emit("update:itemsObject", result);
        this.$store.state.isLoading = false;
      } else {
        this.$bvToast.toast(`${result.errors}`, {
          title: "ผิดพลาด",
          autoHideDelay: 5000,
          variant: "danger",
        });
        this.$store.state.isLoading = false;
      }
    },
    fieldIndex(fieldA, fieldB) {
      return fieldA.index - fieldB.index;
    },
  },
  watch: {
    // dateType() {
    //   if (this.reportType === "animalReport") {
    //     this.filters();
    //   }
    // },
    // fromDate() {
    //   if (this.reportType === "animalReport") {
    //     this.filters();
    //   }
    // },
    // toDate() {
    //   if (this.reportType === "animalReport") {
    //     this.filters();
    //   }
    // },
    // hospitalSelected() {
    //   if (this.reportType === "animalReport") {
    //     this.filters();
    //   }
    // },
    // statusFilter() {
    //   if (this.reportType === "animalReport") {
    //     this.filters();
    //   }
    // },
    // directionFilterSelected() {
    //   if (this.reportType === "animalReport") {
    //     this.filters();
    //   }
    // }
  },
};
</script>

<style lang="scss" scoped>
.filter-wrapper {
  background: #eaeced;
  padding: 1rem;
}

.table-wrapper {
  padding: 2rem;
}
</style>
